import React from 'react'
import { Plan, commissionParts, formatPlanPrice, priceSuffix, publicPlans, setupFeeText } from '../lib/plans'

/**
 * Plan picker for onboarding (W9b). The store's trial runs on the plan picked here, and a plan
 * with a setup fee starts its trial only once that fee is paid (step "Review and go live").
 * Everything shown comes from subscription_plans; an invite link can preselect with ?plan=.
 */
const OnboardingPlanChoice: React.FC<{
  plans: Plan[]
  value: string | null
  onChange: (planId: string) => void
}> = ({ plans, value, onChange }) => {
  const options = publicPlans(plans, 'merchant')
  if (options.length === 0) return null

  return (
    <fieldset className="mb-6">
      <legend className="text-xs text-white/50 mb-2">Your plan *</legend>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {options.map((p) => {
          const price = formatPlanPrice(p)
          const commission = commissionParts(p)
          const setup = setupFeeText(p)
          const selected = value === p.id
          return (
            <label key={p.id}
              className={`cursor-pointer rounded-xl border p-3 transition-colors ${selected ? 'border-orange-500 bg-orange-500/10' : 'border-white/10 hover:border-white/30'}`}>
              <input type="radio" name="ob-plan" className="sr-only" value={p.id} checked={selected} onChange={() => onChange(p.id)} />
              <div className="flex items-baseline justify-between gap-2">
                <span className="font-semibold text-white">{p.name}</span>
                {p.tagline && <span className="text-[10px] tracking-wider text-white/40">{p.tagline}</span>}
              </div>
              {price && <div className="text-white/80 text-sm mt-1">{price} <span className="text-white/40">{priceSuffix(p)}</span></div>}
              {commission && <div className="text-white/60 text-xs">{commission[0]} {commission[1]}</div>}
              {setup && <div className="text-white/40 text-xs mt-1">One-off setup: {setup}</div>}
            </label>
          )
        })}
      </div>
    </fieldset>
  )
}

export default OnboardingPlanChoice
